import { FormattedMessage, FormattedNumber } from 'react-intl'
import { keepPreviousData } from '@tanstack/react-query'

import { Skeleton } from '@gto/ui/skeleton'
import { Typography } from '@gto/ui/typography'

import { useAccountEarningsList } from '@/api/gen'
import { IconEdgeCoin } from '@/assets/icons'
import { useAuth } from '@/hooks/use-auth'

import { StatsBoxWrapper } from './stats-box-wrapper'

export const CurrentMonthEarnings = () => {
  const { isAuthorized, isInitialized } = useAuth()

  const { data, isFetching } = useAccountEarningsList(
    {
      period: 'this_month',
    },
    {
      query: {
        refetchOnWindowFocus: false,
        staleTime: 1000 * 60 * 5,
        gcTime: 1000 * 60 * 10,
        placeholderData: keepPreviousData,
        enabled: isAuthorized,
      },
    },
  )

  const thisMonthSumm = data?.reduce((acc, item) => {
    acc += Number(item.edge_earned) || 0

    return acc
  }, 0)

  return (
    <StatsBoxWrapper
      className="flex-[1_1_0px] md:flex-[1_0_100%]"
      title={<FormattedMessage id="rewards.stats.earnedThisMonth.title" />}
    >
      <div className="flex items-center gap-2">
        {isFetching || !isInitialized ? (
          <Skeleton
            height={46}
            variant="rectangular"
            width={250}
          />
        ) : (
          <>
            <Typography
              color="info"
              variant="h3"
            >
              <FormattedNumber value={thisMonthSumm ?? 0} />
            </Typography>
            <IconEdgeCoin
              height={46}
              width={46}
            />
          </>
        )}
      </div>
    </StatsBoxWrapper>
  )
}
